export function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/moment/creation-data.js
// module id = 935
// module chunks = 113